import { render } from "./WantList.vue?vue&type=template&id=2fac215f&ts=true"
import script from "./WantList.vue?vue&type=script&lang=ts"
export * from "./WantList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__